<onyx-badge [color]="status().color" [size]="20">
  {{ `${DictionaryCode.DELEGATION_STATUS}.${status().name}` | translate }}
</onyx-badge>

@if (actionButton(); as button) {
  <span>·</span>

  <onyx-button
    variant="outlined"
    [size]="24"
    [disabled]="!!button.disabled"
    [onyxTooltip]="button.tooltip"
    (click)="!button.disabled ? button.value() : null"
  >
    {{ button.name | translate }}
  </onyx-button>
}
